import React from 'react'
import PropTypes from 'prop-types'
import disabledPreviousIcon from '../images/disabledPreviousIcon.svg'
import disabledNextIcon from '../images/disabledNextIcon.svg'
import disabledStartIcon from '../images/disabledStartIcon.svg'
import disabledEndIcon from '../images/disabledEndIcon.svg'
import enabledPreviousIcon from '../images/enabledPreviousIcon.svg'
import enabledNextIcon from '../images/enabledNextIcon.svg'
import enabledStartIcon from '../images/enabledStartIcon.svg'
import enabledEndIcon from '../images/enabledEndIcon.svg'

const propTypes = {
  // items: PropTypes.array.isRequired,
  items: PropTypes.array,
  onChangePage: PropTypes.func.isRequired,
  initialPage: PropTypes.number
}

class Pagination extends React.Component {
  static defaultProps = {
    initialPage: 1
  }

  constructor (props) {
    super(props)
    this.state = {
      pager: {},
      value: 30,
      pageSize: 30
    }
  }

  componentWillMount () {
    if (this.props.items && this.props.items.length) {
      this.setPage(this.props.initialPage, this.state.pageSize)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.items !== prevProps.items) {
      this.setPage(this.props.initialPage, this.state.pageSize)
    }
  }

  setPage (page, pageSize) {
    this.props.getPage(page, pageSize)
    var { items } = this.props
    var pager = this.state.pager

    if (page < 1 || page > pager.totalPages) {
      return
    }

    pager = this.getPager(items.length, page, pageSize)
    var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1)
    this.setState({ pager: pager })

    this.props.onChangePage(pageOfItems)
  }

  getPager (totalItems, currentPage, pageSize) {
    currentPage = currentPage || 1

    pageSize = pageSize || 10

    var totalPages = Math.ceil(totalItems / pageSize)

    var startPage, endPage
    if (totalPages <= 10) {
      startPage = 1
      endPage = totalPages
    } else {
      if (currentPage <= 6) {
        startPage = 1
        endPage = 10
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9
        endPage = totalPages
      } else {
        startPage = currentPage - 5
        endPage = currentPage + 4
      }
    }

    var startIndex = (currentPage - 1) * pageSize
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1)

    var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i)

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    }
  }

  getPerPage (number) {
    this.setState({
      value: number,
      pageSize: number
    })
    this.setPage(1, number)
  }

  getStart () {
    var pager = this.state.pager
    if (!pager.pages || pager.pages.length <= 1) {
      return null
    }
    return (
      <td
        className='titlePage'
        style={styles.startPage}
        onClick={() => this.setPage(1, this.state.pageSize)}
      >
        <div>
          <button
            style={styles.buttonStyle}
          >
            {pager.currentPage === 1
              ? (<img
                style={styles.imgStyle}
                src={disabledStartIcon}
                alt='true'
              />)
              : (<img
                style={styles.imgStyle}
                src={enabledStartIcon}
                alt='true'
              />)
            }
          </button>
        </div>
      </td>
    )
  }

  getPreviousPage () {
    var pager = this.state.pager
    if (!pager.pages || pager.pages.length <= 1) {
      return null
    }
    return (
      <td>
        <div className='previousAlign'>
          <button
            style={styles.buttonStyle}
            onClick={() => this.setPage(pager.currentPage - 1, this.state.pageSize)}
          >
            { pager.currentPage === 1
              ? (<img
                style={styles.imgStyle}
                src={disabledPreviousIcon}
                alt='true'
              />)
              : (<img
                style={styles.imgStyle}
                src={enabledPreviousIcon}
                alt='true'
              />)
            }
          </button>
        </div>
      </td>
    )
  }

  getNextPage () {
    var pager = this.state.pager
    if (!pager.pages || pager.pages.length <= 1) {
      return null
    }
    return (
      <td>
        <div className='nextAlign'>
          <button
            style={styles.buttonStyle}
            onClick={() => this.setPage(pager.currentPage + 1, this.state.pageSize)}
          >
            {pager.currentPage === pager.totalPages
              ? (<img
                style={styles.imgStyle}
                src={disabledNextIcon}
                alt='true'
              />)
              : (<img
                style={styles.imgStyle}
                src={enabledNextIcon}
                alt='true'
              />)
            }
          </button>
        </div>
      </td>
    )
  }

  getEnd () {
    var pager = this.state.pager
    if (!pager.pages || pager.pages.length <= 1) {
      // don't display pager if there is only 1 page
      return null
    }
    return (
      <td
        className='titlePage'
        style={styles.endPage}
        onClick={() => this.setPage(pager.totalPages, this.state.pageSize
        )}
      >
        <div>
          <button
            style={styles.buttonStyle}
          >
            {pager.currentPage === pager.totalPages
              ? (<img
                style={styles.imgStyle}
                src={disabledEndIcon}
                alt='true'
              />)
              : (<img
                style={styles.imgStyle}
                src={enabledEndIcon}
                alt='true'
              />)
            }
          </button>
        </div>
      </td>
    )
  }

  get10 () {
    return (
      this.state.value === 10
        ? <td
          style={styles.per10Active}
          onClick={() => this.getPerPage(10)}
        >
          <div>
            <button
              style={styles.buttonStyle}
            >
              <span style={styles.spanPer10Active}>
                      10
              </span>
            </button>
          </div>
        </td>
        : <td
          style={styles.per10Inactive}
          onClick={() => this.getPerPage(10)}
        >
          <div>
            <button
              style={styles.buttonStyle}
            >
              <span style={styles.spanPer10Inactive}>
                10
              </span>
            </button>
          </div>
        </td>
    )
  }

  get30 () {
    var pager = this.state.pager
    return (
      pager.totalItems <= 50 ? (this.state.value === 30
        ? <td
          style={styles.per30ActiveBorder}
          onClick={() => this.getPerPage(30)}
        >
          <div>
            <button style={styles.buttonStyle}>
              <span style={styles.spanPer30Active}>
                30
              </span>
            </button>
          </div>
        </td>
        : <td
          style={styles.per30InactiveBorder}
          onClick={() => this.getPerPage(30)}
        >
          <div>
            <button style={styles.buttonStyle}>
              <span style={styles.spanPer30Inactive}>
                30
              </span>
            </button>
          </div>
        </td>
      )
        : (this.state.value === 30
          ? <td
            style={styles.per30Active}
            onClick={() => this.getPerPage(30)}
          >
            <div>
              <button style={styles.buttonStyle}>
                <span style={styles.spanPer30Active}>
                  30
                </span>
              </button>
            </div>
          </td>
          : <td
            style={styles.per30Inactive}
            onClick={() => this.getPerPage(30)}
          >
            <div>
              <button style={styles.buttonStyle}>
                <span style={styles.spanPer30Inactive}>
                  30
                </span>
              </button>
            </div>
          </td>
        )
    )
  }

  get50 () {
    var pager = this.state.pager
    return (
      pager.totalItems > 50 ? (this.state.value === 50
        ? <td
          style={styles.per50Active}
          onClick={() => this.getPerPage(50)}
        >
          <div>
            <button style={styles.buttonStyle}>
              <span style={styles.spanPer50Active}>
                50
              </span>
            </button>
          </div>
        </td>
        : <td
          style={styles.per50Inactive}
          onClick={() => this.getPerPage(50)}
        >
          <div>
            <button style={styles.buttonStyle}>
              <span style={styles.spanPer50Inactive}>
                50
              </span>
            </button>
          </div>
        </td>
      ) : null
    )
  }

  render () {
    var pager = this.state.pager
    if (!pager.pages || pager.pages.length <= 1) {
      return null
    }
    return (
      <div
        className='paginationStyle'
      >
        <div style={styles.lineStyle} />
        <div>
          <table
            style={styles.table}
          >
            <tbody>
              <tr>
                {this.getStart()}
                {this.getPreviousPage()}
                {pager.pages.map((page, index) =>
                  <td
                    key={index}
                    className={pager.currentPage === page
                      ? 'numberActive'
                      : 'numberInactive'
                    }
                    onClick={() => this.setPage(page, this.state.pageSize)}
                  >
                    <span>{page}</span>
                  </td>
                )}
                {this.getNextPage()}
                {this.getEnd()}
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <table className='table10' cellSpacing='0' cellPadding='0'
          >
            <tbody>
              <tr>
                {this.get10()}
                {this.get30()}
                {this.get50()}
                <td style={styles.parPageStyle}>
                  par page
                </td>
                <td
                  className='resumePage'
                  style={styles.resume}>
                  {pager.currentPage === 1
                    ? <span>{pager.currentPage}-{this.state.value} sur {this.props.items.length}</span>
                    : <span>{((pager.currentPage - 1) * this.state.value) + 1}-{pager.currentPage * this.state.value} sur {this.props.items.length}</span>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

const styles = {
  lineStyle: {
    marginLeft: '14px',
    marginTop: '40px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    borderColor: '#272C30'
  },
  table: {
    marginTop: '40px',
    width: '98%',
    height: '40px',
    marginLeft: '14px',
    marginRight: '14px'
  },
  spanStart: {
    cursor: 'pointer'
  },
  startPage: {
    textAlign: 'left',
    width: '200px',
    // fontFamily: 'Roboto-Regular',
    color: '#A6B9C8',
    fontSize: '15px'
  },
  endPage: {
    textAlign: 'right',
    width: '200px',
    // fontFamily: 'Roboto-Medium',
    color: '#E3E3E3',
    fontSize: '15px'
  },
  buttonStyle: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none'
  },
  imgStyle: {
    width: '27px',
    height: '28px'
  },
  spanPer10Active: {
    color: '#272D31',
    fontWeight: 'bold'
  },
  spanPer10Inactive: {
    color: '#A6B9C8'
  },
  spanPer30Active: {
    color: '#272D31',
    fontWeight: 'bold'
  },
  spanPer30Inactive: {
    color: '#A6B9C8'
  },
  spanPer50Active: {
    color: '#272D31',
    fontWeight: 'bold'
  },
  spanPer50Inactive: {
    color: '#A6B9C8'
  },
  per10Active: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#A6B9C8',
    fontSize: '14px',
    // fontFamily: 'Roboto-Bold',
    borderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px'
  },
  per10Inactive: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#272D31',
    fontSize: '14px',
    // fontFamily: 'Roboto-Bold',
    borderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px'
  },
  per30Active: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#A6B9C8',
    fontSize: '14px'
    // fontFamily: 'Roboto-Regular',
  },
  per30Inactive: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#272D31',
    fontSize: '14px'
    // fontFamily: 'Roboto-Regular',
  },
  per30ActiveBorder: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#A6B9C8',
    fontSize: '14px',
    // fontFamily: 'Roboto-Regular',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  per30InactiveBorder: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#272D31',
    fontSize: '14px',
    // fontFamily: 'Roboto-Regular',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  per50Active: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#A6B9C8',
    fontSize: '14px',
    // fontFamily: 'Roboto-Regular',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  per50Inactive: {
    cursor: 'pointer',
    width: '10%',
    backgroundColor: '#272D31',
    fontSize: '14px',
    // fontFamily: 'Roboto-Regular',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px'
  },
  parPageStyle: {
    width: '10%',
    backgroundColor: '#15191C',
    color: '#E3E3E3',
    // fontFamily: 'Roboto-Medium'
    fontSize: '15px'
  },
  resume: {
    textAlign: 'right',
    // width: '80%',
    backgroundColor: '#15191C',
    color: '#E3E3E3',
    // fontFamily: 'Roboto-Medium'
    fontSize: '15px'
  }

}

Pagination.propTypes = propTypes

export default Pagination
